import { GET_PROJECT_USERS, GET_PROJECT_USERS_ERR } from '../../actionTypes/projectType'
import { projectUsersApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getProjectUsers = (payload) => async (dispatch) => {
    try {
        let results = await axios.get(`${projectUsersApi}/${payload.page}`, await accessToken())
        let data = results && results.data
        console.log('GET ASSIGN PROJECTS', data)
        dispatch({
            type: GET_PROJECT_USERS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_PROJECT_USERS_ERR,
            payload: error.response,
        });
    }
};


